import { useQuery } from "@tanstack/react-query";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://insightpanel.sembian.net";

const getWhitepapers = async () => {
  const response = await fetch(`${API_BASE_URL}/api/whites`);
  const data = await response.json();
  return data;
};

export default getWhitepapers;

/**
 * React Query hook to get all whitepapers
 * @returns {Object} Query result with data, isLoading, error, etc.
 */
export const useWhitepapers = () => {
  return useQuery({
    queryKey: ["whitepapers"],
    queryFn: getWhitepapers,
    staleTime: 30 * 60 * 1000, // 30 minutes - whitepapers don't change frequently
    gcTime: 60 * 60 * 1000, // 1 hour - keep in cache for 1 hour
  });
};
